module.exports = __webpack_public_path__ + "static/media/game-bg-mobile.1c88545f.jpg";